module.exports = __webpack_public_path__ + "img/2nd-mortgage-landing-page-photo.4c2ad6a.jpg";